// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3ynQ1","header":"PatientBlock_header__2dVb0","label":"PatientBlock_label__1-e5U","option":"PatientBlock_option__1-oXC"};